import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useBillingProvider} from "../hooks/useBillingProvider.ts";
import {BillingProvider} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useBillingProvider();

    return (
        <FormDrawer
            record={{
                id: '',
                key: '',
                name: '',
                description: '',
                status: 'Enabled',
            } as BillingProvider}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
